var _circle, _circle2, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCactusEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.001,
    cy: 18.95,
    r: 18.95,
    fill: "#DFE1E7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "94ybaejada",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.001,
    cy: 18.95,
    r: 18.95,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#94ybaejada)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.656 18.953c-4.327-.13-6.318 5.433-13.422 5.996-3.19.252-4.422-1.176-8.096-.575-3.502.572-6.064 2.472-7.72 4.051h37.9c-3.38-9.427-6.445-9.403-8.662-9.473z",
    fill: "#F0F2F6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.013 31.634V18.078h3.734a1.188 1.188 0 0 0 1.177-1.186V9.34a1.188 1.188 0 0 0-1.177-1.19h-.146a1.188 1.188 0 0 0-1.177 1.19v5.483a.73.73 0 0 1-.21.514.714.714 0 0 1-.508.213h-1.693V8.12c0-.887-.71-1.606-1.588-1.606a1.574 1.574 0 0 0-1.124.47 1.61 1.61 0 0 0-.464 1.136v11.52h-1.13a.727.727 0 0 1-.723-.73v-7.467a1.288 1.288 0 0 0-1.002-1.286 1.238 1.238 0 0 0-1.037.26c-.29.24-.457.6-.457.978v9.508c0 .697.559 1.262 1.248 1.262h3.1v9.47c0 .19.153.344.341.344h2.496c.09 0 .177-.037.24-.101a.346.346 0 0 0 .1-.244z",
    fill: "#9EA3B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.623 29.719a3.117 3.117 0 0 1-.633-.321c-.341-.223-.525-.465-.879-.708a3.661 3.661 0 0 0-.594-.327 4.83 4.83 0 0 0-2.428-.524c-.778.065-.633.301-1.556.373-.632.053-.986-.052-1.435.203-.323.19-.234.295-.664.655-.434.278-.887.526-1.353.74a3.192 3.192 0 0 0-.81.505 2.066 2.066 0 0 0-.373 1.664h12.508a.784.784 0 0 0 .461-.459.917.917 0 0 0-.12-.655 1.826 1.826 0 0 0-.468-.655c-.442-.347-.759-.138-1.656-.491z",
    fill: "#C6C9D5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCactusEmptyState);
export default __webpack_public_path__ + "static/media/cactus-empty-state.9cb2effc1dbbd7700b44480acc73b652.svg";
export { ForwardRef as ReactComponent };